import {
  put, takeLatest, all, select, call,
} from 'redux-saga/effects';
import { delay } from 'redux-saga';

import { stopAllCredits, stoppedAllCredits } from './actions';

import { stopAllCredits as stopAllCreditsApi } from './api';

function* doStopAllCredits() {
  yield delay(750);
  yield call(stopAllCreditsApi);
  yield put(stoppedAllCredits());
}

function* watcher(context) {
  yield all([takeLatest(stopAllCredits().type, doStopAllCredits)]);
}

export default watcher;
